import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import axios, { API, formatApiError } from "@/lib/apiClient";

const SITE_KEY = process.env.REACT_APP_HCAPTCHA_SITE_KEY;

export const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const captchaRef = useRef(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!captchaToken) {
      setError("Please complete the captcha.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/auth/forgot-password`, { email, captcha_token: captchaToken });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
      captchaRef.current?.resetCaptcha();
      setCaptchaToken("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-[80vh] items-center justify-center px-6">
      <div className="w-full max-w-sm rounded-lg border border-surface-border bg-surface-card p-8 fade-up">
        <h1 className="mb-2 font-heading text-2xl font-bold text-white">Sovereign Recovery</h1>
        <p className="mb-6 text-sm text-slate-400">Enter your account email and we'll send a password reset link.</p>
        {sent ? (
          <p className="text-sm text-truth-green" data-testid="forgot-password-sent">If that email exists, a reset link has been sent.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
            <Input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="border-surface-border bg-obsidian text-white" data-testid="forgot-password-email-input" />
            {SITE_KEY && (
              <HCaptcha
                ref={captchaRef}
                sitekey={SITE_KEY}
                onVerify={(token) => setCaptchaToken(token)}
                onExpire={() => setCaptchaToken("")}
                data-testid="forgot-password-hcaptcha"
              />
            )}
            {error && <p className="text-sm text-sovereign" data-testid="forgot-password-error">{error}</p>}
            <Button type="submit" disabled={loading || !captchaToken} className="w-full bg-sovereign text-white hover:bg-sovereign/90" data-testid="forgot-password-submit-btn">
              {loading ? "Sending..." : "Send reset link"}
            </Button>
          </form>
        )}
        <p className="mt-4 text-center text-sm text-slate-500">
          <Link to="/login" className="text-sovereign" data-testid="forgot-password-login-link">Back to login</Link>
        </p>
      </div>
    </div>
  );
};
